import { createSelector } from 'reselect';

// Config
import { getBasketUrlSelector } from '@redux/reducers/bff/bffSelector';
import {
  getShowBatchingFailureModalSelector,
  getShowRemoveBatchingFailureItemErrorSelector,
} from '@redux/reducers/user/userSelector';
import {
  getBatchingFailureItemsSelector,
  getAllItemsHaveBatchingFailureSelector,
} from '@redux/reducers/order-form/orderFormSelector';

const batchingFailureModalState = createSelector(
  [
    getBasketUrlSelector,
    getAllItemsHaveBatchingFailureSelector,
    getBatchingFailureItemsSelector,
    getShowRemoveBatchingFailureItemErrorSelector,
    getShowBatchingFailureModalSelector,
  ],
  (basketUrl, allItemsHaveBatchingFailure, batchingFailureItems, removeItemsFailed, showModal) => ({
    basketUrl,
    allItemsHaveBatchingFailure,
    batchingFailureItems,
    removeItemsFailed,
    showModal,
  }),
);

export default batchingFailureModalState;
